import { unwrap, type SagotApi } from "@sagot/api-client";
import type { components } from "@sagot/api-client";

type SourceView = components["schemas"]["SourceView"];

/** API page cap (`limit` ≤ 200 on `GET /v1/sources`). */
export const SOURCES_PAGE_SIZE = 200;
/** Most sources one screen loads (five full pages); a workspace beyond that is a plan-limit case. */
export const SOURCES_MAX = 1000;

/**
 * Every live source of the workspace, newest first: the endpoint pages (`limit`/`offset`), so the
 * screens that filter or count client-side must walk the pages instead of seeing only the first.
 */
export async function fetchAllSources(api: SagotApi): Promise<SourceView[]> {
  const all: SourceView[] = [];
  while (all.length < SOURCES_MAX) {
    const page = await unwrap(api.GET("/v1/sources", { params: { query: { limit: SOURCES_PAGE_SIZE, offset: all.length } } }));
    all.push(...page);
    if (page.length < SOURCES_PAGE_SIZE) break;
  }
  return all;
}
